module.exports = __webpack_public_path__ + "static/media/Eurosport_Logo.28e0a946.svg";